"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function DigitalAssetsOverview() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="digital-assets-overview" className="dark bg-background text-foreground relative h-[30vh] min-h-[400px] overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1545031/img/trading_terminals_background.png)] bg-cover bg-center" style={{
      transform: "translateZ(0)",
      willChange: "transform"
    }} />

      {}
      <div className="absolute inset-0 bg-dark-section/80" />

      {}
      <div ref={contentRef} className={`relative z-10 flex h-full flex-col items-center justify-center px-4 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "animate-reveal" : "opacity-0 translate-y-5"}`}>
        <h2 className="mb-4 font-display text-[clamp(2rem,4.5vw,2.75rem)] font-semibold leading-[1.3] tracking-tight text-white">
          Digital Assets Overview
        </h2>
        <p className="mb-8 max-w-2xl text-lg leading-[1.6] text-white/90">
          Systematic strategies and disciplined execution in digital asset markets, built on institutional governance and risk management frameworks.
        </p>

        {}
        <Link to="/WIMCODigitalPage">
          <Button variant="outline" size="lg" className="group border-2 border-accent bg-transparent text-white hover:bg-accent hover:text-foreground-accent transition-all duration-[var(--duration-fast)] ease-[var(--ease-smooth)] focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2">
            Explore Trading
          </Button>
        </Link>
      </div>
    </section>;
}